var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-app-bar",
        { attrs: { app: "", flat: "", "clipped-left": "", dense: "" } },
        [
          _vm.isAuthenticated
            ? _c(
                "v-menu",
                {
                  attrs: {
                    transition: "slide-y-transition",
                    "offset-y": "",
                    bottom: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-app-bar-nav-icon",
                              _vm._g({ staticClass: "hidden-sm-and-up" }, on)
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1301737555
                  ),
                },
                [
                  _c(
                    "v-list",
                    _vm._l(_vm.leftNavMenu, function (item) {
                      return _c(
                        "v-list-item",
                        { key: item.title, attrs: { to: item.to } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                [
                                  _vm._v(_vm._s(item.title)),
                                  item.chip
                                    ? _c(
                                        "v-chip",
                                        { attrs: { color: "accent" } },
                                        [_vm._v(" " + _vm._s(item.chip) + " ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("v-toolbar-title", [
            _c("a", { attrs: { href: "/" } }, [
              _c("img", {
                staticClass: "mt-2",
                attrs: {
                  height: "50",
                  src: require("@/assets/rex-analytics-logo.svg"),
                },
              }),
            ]),
          ]),
          _vm.isAuthenticated
            ? [
                _c(
                  "v-toolbar-items",
                  { staticClass: "hidden-xs-only" },
                  _vm._l(_vm.leftNavMenu, function (item) {
                    return _c(
                      "v-btn",
                      {
                        key: item.title,
                        attrs: {
                          to: item.to,
                          exact: "",
                          depressed: "",
                          ripple: "",
                        },
                      },
                      [
                        _vm._v(_vm._s(item.title) + " "),
                        item.chip
                          ? _c("v-chip", { attrs: { color: "accent" } }, [
                              _vm._v(" " + _vm._s(item.chip) + " "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-1",
                    attrs: {
                      to: "/docs",
                      exact: "",
                      depressed: "",
                      ripple: "",
                    },
                  },
                  [_vm._v(" API ")]
                ),
                _c("AppMenu"),
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-1",
                    attrs: {
                      to: "/wiki",
                      exact: "",
                      depressed: "",
                      ripple: "",
                    },
                  },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c("v-icon", _vm._g({}, on), [
                                    _vm._v("mdi-help-circle-outline"),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2575987712
                        ),
                      },
                      [_c("span", [_vm._v("Wiki")])]
                    ),
                  ],
                  1
                ),
                _vm.isAuthenticated
                  ? _c(
                      "v-menu",
                      {
                        attrs: {
                          bottom: "",
                          "min-width": "200px",
                          rounded: "",
                          "offset-y": "",
                          "close-on-content-click": false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g({ attrs: { icon: "" } }, on),
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "primary white--text",
                                          attrs: { left: "", size: "35" },
                                        },
                                        [
                                          _vm.currentUser.picture
                                            ? _c("img", {
                                                attrs: {
                                                  src: _vm.currentUser.picture,
                                                },
                                              })
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentUser.email
                                                        .slice(0, 1)
                                                        .toUpperCase()
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2400901228
                        ),
                      },
                      [
                        _c(
                          "v-card",
                          [
                            _c(
                              "v-list-item-content",
                              { staticClass: "justify-center" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mx-auto text-center" },
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        staticClass: "primary white--text",
                                        attrs: { color: "primary", left: "" },
                                      },
                                      [
                                        _vm.currentUser.picture
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.currentUser.picture,
                                              },
                                            })
                                          : _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.currentUser.email
                                                      .slice(0, 1)
                                                      .toUpperCase()
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "text-caption mt-1" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currentUser.email) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("v-divider", { staticClass: "my-3" }),
                                    _vm.isAcelerex
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "px-4 pb-3",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c("div", { staticClass: "mb-3" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-caption text--secondary mb-1",
                                                },
                                                [_vm._v("Current Organization")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                    },
                                                    [_vm._v("mdi-domain")]
                                                  ),
                                                  _vm.currentOrganization
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-body-2 font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .currentOrganization
                                                                  .name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-body-2 font-italic",
                                                        },
                                                        [_vm._v("Loading")]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "search-input":
                                                  _vm.organizationSearch,
                                                label: "Switch",
                                                items: _vm.organizations,
                                                "item-text": "name",
                                                "item-value": "id",
                                                "return-object": "",
                                                "prepend-inner-icon":
                                                  "mdi-swap-horizontal",
                                                "append-icon":
                                                  "mdi-content-save",
                                                loading: _vm.searchLoading,
                                                "hide-details": "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              on: {
                                                "update:searchInput": function (
                                                  $event
                                                ) {
                                                  _vm.organizationSearch =
                                                    $event
                                                },
                                                "update:search-input":
                                                  function ($event) {
                                                    _vm.organizationSearch =
                                                      $event
                                                  },
                                                "click:append":
                                                  _vm.updateOrganization,
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                              model: {
                                                value: _vm.organizationSelected,
                                                callback: function ($$v) {
                                                  _vm.organizationSelected = $$v
                                                },
                                                expression:
                                                  "organizationSelected",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          depressed: "",
                                          rounded: "",
                                          text: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.logout.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [_vm._v("mdi-logout")]),
                                        _vm._v(" Logout "),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("v-main", [_c("router-view")], 1),
      _c(
        "v-footer",
        { attrs: { app: "", padless: "", color: "secondary" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center", dense: "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center white--text",
                  attrs: { cols: "12" },
                },
                [
                  _c("strong", [_vm._v("Acelerex v" + _vm._s(_vm.version))]),
                  _vm._v(
                    " — ©2017-" + _vm._s(_vm.currentYear) + " Acelerex Inc. "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }